import {
  addCustomEmailValidator,
  addCustomPhoneValidator,
  addCustomValidationMessages,
  toggleActiveClassEachLabel,
} from "./modules/form.js";

(function ($) {
  $(function () {
    const formWizard = $("form.form-wizard");
    const wizard = $("#wizard", formWizard);

    addCustomEmailValidator(jQuery);
    addCustomPhoneValidator(jQuery);
    addCustomValidationMessages(jQuery);

    if (formWizard && wizard && formWizard.data("formWizard")) {
      formWizard.validate({
        errorPlacement: function errorPlacement(error, element) {
          if (error && element) {
            let parent = element.parent();
            let feedback = parent.find(".feedback");

            if (feedback.length === 0) {
              parent = parent.parent();
              feedback = parent.find(".feedback");
            }

            if (feedback.length === 0) {
              element.after(error);
            } else {
              feedback.html(error);
            }
            // $(element).parent().append(error);
          }
        },
        rules: {
          nom: "required",
          prenom: "required",
          email: {
            required: true,
            email: true,
            customEmail: true,
          },
          phone: {
            required: true,
            customPhone: true,
          },
        },
      });
    }

    // input select
    inputForm($);

    // Ajouter/retirer la classe "active sur le label d'un input cible
    toggleActiveClassEachLabel($(".ci-Form-group .ci-Form-input"));
  });
})(jQuery);
